<template>
  <div class="home-page">
    <div class="panel">
      <div class="carousel" style="height: 150px; position: relative; overflow: hidden; border-radius: 8px;">
        <div class="carousel-gradient-bottom"></div>
        <div class="carousel-item" v-for="(item, index) in carouselItems" :key="index"
             :style="{ display: currentSlide === index ? 'block' : 'none' }">
          <div
              style="height: 100%; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(34, 211, 238, 0.1) 50%, rgba(16, 185, 129, 0.15) 100%); color: #e8e8e8; padding: 20px; border: 1px solid rgba(139, 92, 246, 0.2); border-radius: 8px;">
            <div style="text-align: center;">
              <h3 style="margin-bottom: 10px; background: linear-gradient(90deg, #c4b5fd 0%, #a5f3fc 50%, #bbf7d0 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; font-size: 24px; font-weight: 700;">
                {{ item.title }}</h3>
              <p style="color: #a0a0a0; font-size: 14px;">{{ item.content }}</p>
            </div>
          </div>
        </div>
        <div class="carousel-indicators"
             style="position: absolute; bottom: 10px; left: 0; right: 0; display: flex; justify-content: center; gap: 10px;">
          <button v-for="(item, index) in carouselItems" :key="index" @click="currentSlide = index"
                  :style="{ width: '12px', height: '12px', borderRadius: '50%', border: currentSlide === index ? '2px solid #8b5cf6' : 'none', background: currentSlide === index ? 'linear-gradient(135deg, #8b5cf6 0%, #22d3ee 100%)' : 'rgba(139, 92, 246, 0.3)', cursor: 'pointer', boxShadow: currentSlide === index ? '0 0 10px rgba(139, 92, 246, 0.5)' : 'none', transition: 'all 0.3s ease' }"></button>
        </div>
      </div>
    </div>

    <div class="panel">
      <div class="panel-header">
        <h2 class="panel-title"><i class="fas fa-chart-line"></i> 直播数据大屏</h2>
      </div>
      <div class="data-grid">
        <div class="data-card account-card">
          <div class="card-header">
            <i class="fas fa-user"></i>
            <span class="card-label">当前直播账号</span>
          </div>
          <div class="nickname">{{ userInfo?.platform?.nickname || '未登录' }}</div>
          <div class="live_status" v-if="userInfo?.platform">
            <span class="online" v-if="userInfo?.platform?.live_status">
              直播中
            </span>
            <span class="offline" v-else>
              未直播
            </span>

          </div>


        </div>

        <div class="data-card">
          <div class="card-header">
            <i class="fas fa-users"></i>
            <span class="card-label">当前直播间在线人数</span>
          </div>
          <div class="card-value">{{ core?.user_num || 0 }}</div>
          <div class="card-status">实时</div>
        </div>


        <div class="data-card">
          <div class="card-header">
            <i class="fas fa-heart"></i>
            <span class="card-label">当前直播间关注数</span>
          </div>
          <div class="card-value">{{ core?.new_fans_ucnt || 0 }}</div>
          <div class="card-status">实时</div>
        </div>

        <div class="data-card">
          <div class="card-header">
            <i class="fas fa-shopping-cart"></i>
            <span class="card-label">当前直播间成交金额</span>
          </div>
          <div class="card-value">¥{{ core?.price || 0 }}</div>
          <div class="card-status">实时</div>
        </div>

        <div class="data-card">
          <div class="card-header">
            <i class="fas fa-chart-line"></i>
            <span class="card-label">观看成交率（人数）</span>
          </div>
          <div class="card-value">{{ core?.watch_sold_rate || 0 }}%</div>
          <div class="card-status">实时</div>
        </div>


        <div class="data-card">
          <div class="card-header">
            <i class="fas fa-comments"></i>
            <span class="card-label">直播时长</span>
          </div>
          <div class="card-value">{{ core?.live_timer || '-' }}</div>
          <div class="card-status">实时</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import http from "@/utils/http";

export default {
  name: 'Home',
  data() {
    return {
      totalSeconds: null,
      timer: null,
      live_timer:null,
      currentSlide: 0,
      carouselItems: [
        {title: '欢迎使用全球播', content: '智能直播中控，让直播更简单'},
        {title: '语音场控', content: '智能语音场控管理'},
        {title: '语音回复', content: '智能语音回复系统'},
        {title: '文字场控', content: '高效管理直播场控团队'}
      ],
      core: {},
    }
  },
  computed: {

    userInfo() {

      return this.$store.state.userInfo

    }

  },
  methods: {
    parseTime(str) {
      console.log(str)
      const [h, m, s] = str.split(':').map(Number);
      return h * 3600 + m * 60 + s;
    },
    format() {
      const h = Math.floor(this.totalSeconds / 3600);
      const m = Math.floor((this.totalSeconds % 3600) / 60);
      const s = this.totalSeconds % 60;
      return [h, m, s].map(v => String(v).padStart(2, '0')).join(':');
    },
    start() {
      this.core.live_timer = this.format();
      this.totalSeconds++;
      console.log(this.totalSeconds)
    },
    async getCore() {

      const res = await http.get("api/user/getcore")

      this.core = res.data;


    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.live_timer)
  },

  async mounted() {
    await this.getCore();
    this.timer = setInterval(this.getCore, 5000)
    if (this.core?.live_timer) {
      this.totalSeconds = this.parseTime(this.core.live_timer);
      this.start();
      this.live_timer=setInterval(this.start, 1000);
    }

    setInterval(() => {
      this.currentSlide = (this.currentSlide + 1) % this.carouselItems.length
    }, 4000)
  }
}
</script>

<style lang="less" scoped>
.home-page {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.carousel-gradient-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background: linear-gradient(to top, rgba(20, 20, 20, 0.8) 0%, transparent 100%);
  pointer-events: none;
  z-index: 1;
}

.panel {
  background: linear-gradient(135deg, rgba(35, 35, 35, 0.95) 0%, rgba(25, 25, 25, 0.95) 100%);
  backdrop-filter: blur(15px);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(60, 60, 60, 0.5);
  padding: 25px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  overflow: hidden;
}

.panel:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
}

.panel:hover::before {
  transform: scaleX(1);
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 17px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(60, 60, 60, 0.5);
}

.panel-title {
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(90deg, #c4b5fd 0%, #a5f3fc 50%, #bbf7d0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  display: flex;
  align-items: center;
  gap: 10px;
}

.data-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.data-card {
  background: linear-gradient(135deg, rgba(40, 40, 40, 0.95) 0%, rgba(30, 30, 30, 0.95) 100%);
  border-radius: 12px;
  padding: 20px;
  border: 1px solid rgba(60, 60, 60, 0.5);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.data-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #8b5cf6 0%, #22d3ee 50%, #10b981 100%);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.data-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(139, 92, 246, 0.2);
  border-color: rgba(139, 92, 246, 0.4);
}

.data-card:hover::before {
  transform: scaleX(1);
}

.account-card {
  grid-column: span 1;
}

.card-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #666 0%, #888 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  font-size: 24px;
  color: #eee;
}

.online-icon {
  background: linear-gradient(135deg, #777 0%, #999 100%);
}

.order-icon {
  background: linear-gradient(135deg, #666 0%, #888 100%);
}

.follow-icon {
  background: linear-gradient(135deg, #777 0%, #999 100%);
}

.money-icon {
  background: linear-gradient(135deg, #666 0%, #888 100%);
}

.rate-icon {
  background: linear-gradient(135deg, #777 0%, #999 100%);
}

.exposure-icon {
  background: linear-gradient(135deg, #666 0%, #888 100%);
}

.interaction-icon {
  background: linear-gradient(135deg, #777 0%, #999 100%);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.card-header i {
  font-size: 16px;
  color: #a78bfa;
}

.card-label {
  font-size: 13px;
  color: #b0b0b0;
  font-weight: 500;
}

.card-value {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(90deg, #c4b5fd 0%, #a5f3fc 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 5px;
}

.card-subtitle {
  font-size: 12px;
  color: #888;
  margin-bottom: 10px;
}

.card-status {
  font-size: 11px;
  color: #888;
  font-weight: 500;
}

.live_status {
  margin-top: 5px;
  font-size: 12px;

}

.online {
  color: #08ff39;
  display: flex;
  align-items: center;
}

.online::before {
  content: ' ';
  display: block;
  width: 10px;
  height: 10px;
  background: #08ff39;

  margin-right: 5px;
  border-radius: 50px;
}

.offline {
  color: red;
  display: flex;
  align-items: center;
}

.offline::before {
  content: ' ';
  display: block;
  width: 10px;
  height: 10px;
  background: red;
  margin-right: 5px;
  border-radius: 50px;
}

@media (max-width: 1200px) {
  .data-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .data-grid {
    grid-template-columns: 1fr;
  }
}
</style>